/**
 * 로드모어 스켈레톤 열 타입 — iOS/Android와 1:1 대칭.
 *
 * - iOS: `SkeletonColumnType(apiValue:)` (MetaFeedProductReactorType.swift)
 * - Android: `SkeletonColumnType.fromApiValue()` (domain/.../SkeletonColumnType.kt)
 *
 * 매핑 규칙: `"3col"`만 `threeCol`, 나머지(null/"2col"/기타) 전부 `twoCol` fallback.
 */
export type SkeletonColumnType = 'twoCol' | 'threeCol';

export const skeletonColumnTypeFromApiValue = (
  value: string | null | undefined,
): SkeletonColumnType => (value === '3col' ? 'threeCol' : 'twoCol');
